import React, { useState, useEffect } from 'react';

import { CommentIcon } from '~/Components/Icons/Icons'
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { adminHttp } from "~/Admin/services/http";
import ValidationError from "~/Components/Forms/ValidationError";
import Moment from "react-moment";
import { toast } from 'react-toastify';

const AdminRegistrationComments = ({ guests, invitation, match, event, ...props }) => {

    const [success, setSuccess] = useState('');
    const [error, setError] = useState(null);
    const [comment, setComment] = useState('');
    const [comments, setComments] = useState([]);

    const endpoint = `/events/${event.id}/invitations/${invitation.id}/comments`;

    const loadData = () => {
        adminHttp
            .get(endpoint)
            .then(res => {
                setComments(res.data);
            })
    };

    useEffect(loadData, [event]);

    const handleChange = (e) => {
        setComment(e.target.value);
    };

    const handleSubmit = () => {
        toast.promise(
            adminHttp.post(endpoint, { 'comment': comment }),
            {
                pending: 'Adding Comment...',
                success: {
                    render(res) {
                        setComment('');
                        setError(null);
                        setComments(res.data?.data);
                        return 'Comment has been added!'
                    }
                },
                error: {
                    render(error) {
                        setSuccess('');
                        setError(error.data?.response?.data);
                        return 'Something went wrong!'
                    }
                }
            }
        )
    };

    return (

        <div>
            <div className="row mt-4">
                <div className="col-12">
                    <h2 className="mb-3">Comments</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-12 mt-3">
                    <p className="text-primary font-weight-500">
                        <CommentIcon classes="d-inline mr-1" />New Comment
                    </p>
                    {success && (
                        <div className="alert alert-success" role="alert">
                            {success}
                        </div>
                    )}

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving tickets!"}
                        </div>
                    )}
                    <textarea onChange={e => handleChange(e)} value={comment} className="form-control" />
                    <ValidationError errors={error?.errors} name="comment" />
                </div>
                <div className="col-12 mt-3">
                    <small>This comment will only be visible to admins and will not appear on the guest page.</small>
                </div>
                <div className="col-12 mt-3">
                    <button className="btn btn-primary btn-sm" onClick={handleSubmit}>ADD COMMENT</button>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-12">

                    {comments.map(comment => (
                        <div className="mb-3">
                            <div className="text-primary font-weight-500">
                                <CommentIcon classes="d-inline mr-1" />{comment.user.full_name}
                            </div>
                            <div className="pre-line">{comment.comment}</div>
                            <small>
                                <Moment format="DD/MM/YYYY h:mm:ss a" date={comment.created_at} />
                            </small>
                        </div>
                    ))}

                </div>
            </div>

        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(withRouter(AdminRegistrationComments));
